import { Input, Label, Spinner } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { useReleaseAccountLocked } from "../hooks/useEmployee";
import { useState } from "react";
import { showToast } from "../../../utils/toastUtils";
import CustomInput from "../../../Component/BasicComponents/CustomInput";

const AccountLockedModal=({data,toggle,onUnlocked}:any)=>{
    console.log('data',data)
   const [remark, setRemark] = useState("");
   const[isRefresh,setIsRefresh]=useState(false)

    const { mutate:accountLocked,isPending:isSubmit } = useReleaseAccountLocked();

    const handleSubmit = (e: React.FormEvent) => {
       e.preventDefault();

       if(!remark.trim()){
        showToast.warning("Please fill Remark")
        return
       }
       if (remark.trim().length < 3) {
  showToast.warning("Remark must be at least 3 characters long");
  return;
}

      const body = {
        employeeId: data.EmployeeId, // Include employee Id if needed by backend
        remark: remark,
      };
      accountLocked(body,{
        onSuccess:()=>{
          onUnlocked?.();
        toggle()
        }
      });
      
    };
    return (
      <>{

      !data?(<div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>):(     <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

          <div style={{padding:10,backgroundColor:'#E9CCCF', color:'red',border:'1px solid red'}}>Reason: {data.LockedReason}</div>
          
            <div className="form-input position-relative">
              <CustomInput
              label="Remark"
                type={"text"}
                placeholder="Enter Remark"
                onChange={(event) => setRemark(event.target.value)}
                value={remark}
              />
            
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-start mt-3 gap-2">
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            type="submit"
            disabled={isSubmit}
          >
            {isSubmit?"Submitting...":"Submit"}
          </Btn>
          <Btn
            style={{
              backgroundColor: "#F9FAFC",
              color: "#000",
              border: "1px solid #E0E0E0",
            }}
            type="button"
            onClick={() => toggle()}
          >
            Cancel
          </Btn>
        </div>
      </form>
        )
      }
      </>
    );
}
export default AccountLockedModal;